module.exports = __webpack_public_path__ + "h5/img/home-box4-right.d243208d.png";